<template>
 <div >
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal" v-for="entry in entries" :key="entry.uid" id="redaktionBeirat">

      <b-row>
        <b-col cols="12">
          <h2 class="font-color-red">{{entry.redaktionTitel}}</h2>
        </b-col>
      </b-row>

      <template v-for="block in entry.redaktionsmitglieder">
      <b-row v-if="block.__typename == 'redaktionsmitglieder_redaktionsmitglied_BlockType'" :key="block.uid" class="space-b4">
        <b-col cols="12" md="6">
          <h3>{{ block.nameRedaktion }}</h3>
        </b-col>
        <b-col cols="12" md="6">
          <h3>{{ block.mailRedaktion }}
            {{ block.ortRedaktion }}</h3>
        </b-col>
      </b-row>  
      </template>
    
      <b-row>
        <b-col cols="12">
          <h2 class="font-color-red">{{entry.beiratTitel}}</h2>
        </b-col>
      </b-row>
      
      <template v-for="block in entry.beiratsmitglieder">
      <b-row v-if="block.__typename == 'beiratsmitglieder_beiratsmitglied_BlockType'" :key="block.uid">
        <b-col cols="12" md="6">
          <h3>
            {{ block.nameBeirat }}
          </h3>
        </b-col>
         <b-col cols="12" md="6">
          <h3>
            {{ block.ortBeirat }}
          </h3>
        </b-col>
      </b-row>  
      </template>

    </b-container>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  const axios = require("axios");

  export default {
    name: "RadaktionBeirat",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
  },
  data() {
    return {
      entries: [],
      navigationPlaceholder: "Redaktion & Beirat"
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                entries(section: "redaktionBeirat") {
                title,
                uid
                ... on redaktionBeirat_redaktionBeirat_Entry {
                  redaktionTitel,
                  redaktionsmitglieder { # Matrix Field Handle
                    ... on redaktionsmitglieder_redaktionsmitglied_BlockType {
                      __typename # Ensures the response has a field describing the type of block
                      uid,
                      nameRedaktion,
                      mailRedaktion,
                      ortRedaktion
                    }
                  }
                  beiratTitel,
                  beiratsmitglieder { # Matrix Field Handle
                    ... on beiratsmitglieder_beiratsmitglied_BlockType {
                      __typename # Ensures the response has a field describing the type of block
                      uid,
                      nameBeirat,
                      ortBeirat
                    }
                  }
                }
              }
              }
            `,
      },
    }).then((result) => {
      let data = result.data.data.entries;
      console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;
    });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    
</style>